import * as THREE from 'three'

import {
  generateArtworkGeometry,
  generateArtworkUvs,
  updateArtworkGeometry,
  updateArtworkUvs,
} from './artwork'
import {
  generateFrameGeometry,
  generateFrameUvs,
  updateFrameGeometry,
  updateFrameUvs,
} from './frame'
import { type FrameSettings } from '../settings'
import {
  generatePassepartoutCoreGeometry,
  generatePassepartoutCoreUvs,
  generatePassepartoutGeometry,
  generatePassepartoutUvs,
  updatePassepartoutCoreGeometry,
  updatePassepartoutCoreUvs,
  updatePassepartoutGeometry,
  updatePassepartoutUvs,
} from './passepartout'
import { generateVertices } from './vertice'

const defaultFrameSettings: FrameSettings = {
  type: 'frame',
  frameTopSize: 0.2,
  frameRightSize: 0.2,
  frameBottomSize: 0.2,
  frameLeftSize: 0.2,
  frameDepth: 0.3,
  frameInset: 0.1,
  passepartoutTopSize: 0,
  passepartoutRightSize: 0,
  passepartoutBottomSize: 0,
  passepartoutLeftSize: 0,
  passepartoutDepth: 0,
  artworkWidth: 2,
  artworkHeight: 1,
  generateBackFace: false,
}

export const generateGeometry = (
  frameGeometry: THREE.Geometry,
  passepartoutGeometry: THREE.Geometry,
  passepartoutCoreGeometry: THREE.Geometry,
  artworkGeometry: THREE.Geometry,
  frameSettings: FrameSettings,
) => {
  const settings = Object.assign({}, defaultFrameSettings, frameSettings)

  const vertices = generateVertices(settings)

  // Setup frame geometry and UVs
  generateFrameGeometry(frameGeometry, vertices, settings.generateBackFace)
  generateFrameUvs(frameGeometry)

  // Setup mount geometry and UVs
  generatePassepartoutGeometry(passepartoutGeometry, vertices)
  generatePassepartoutCoreGeometry(passepartoutCoreGeometry, vertices)
  generatePassepartoutUvs(passepartoutGeometry)
  generatePassepartoutCoreUvs(passepartoutCoreGeometry)

  // Setup artwork geometry and UVs
  generateArtworkGeometry(artworkGeometry, vertices)
  generateArtworkUvs(
    artworkGeometry,
    settings.artworkWidth,
    settings.artworkHeight,
  )
}

export const updateGeometry = (
  frameGeometry: THREE.Geometry,
  passepartoutGeometry: THREE.Geometry,
  passepartoutCoreGeometry: THREE.Geometry,
  artworkGeometry: THREE.Geometry,
  frameSettings: FrameSettings,
) => {
  const settings = Object.assign({}, defaultFrameSettings, frameSettings)

  const vertices = generateVertices(settings)

  // Update frame geometry and UVs
  updateFrameGeometry(frameGeometry, vertices)
  updateFrameUvs(frameGeometry)

  // Update mount geometry and UVs
  updatePassepartoutGeometry(passepartoutGeometry, vertices)
  updatePassepartoutCoreGeometry(passepartoutCoreGeometry, vertices)
  updatePassepartoutUvs(passepartoutGeometry)
  updatePassepartoutCoreUvs(passepartoutCoreGeometry)

  // Update art geometry and UVs
  updateArtworkGeometry(artworkGeometry, vertices)
  updateArtworkUvs(
    artworkGeometry,
    settings.artworkWidth,
    settings.artworkHeight,
  )
}
